import { ConfigRelAgendamentoAmbiente } from './../../../models/configrelagendamentoambiente.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbConfiguracaoAgendRelAmb } from 'app/abstract/full-pages/configuracoes/configuracao-agend-rel-amb.abstract';


@Injectable({
  providedIn: 'root'
})
export class ConfigRelAgendAmbService extends AbConfiguracaoAgendRelAmb {
  constructor(http: HttpClient) {
    super(http);
  }

  public getConfigRelAgendAmb(): Observable<any> {
    return this.get(`config_rel_agendamento_ambiente`);
  }

  public saveConfigRelAgendAmb(config: ConfigRelAgendamentoAmbiente): Observable<any> {
    return this.save(`config_rel_agendamento_ambiente/`, config);
  }
}
